import React from 'react';
import { Container } from './Container';
import { heroImage } from '../data/content';
const flow = ['Home printer', 'Printed templates', 'Finished 3D toys'];
const steps = [{
  label: 'Print',
  tint: 'bg-white text-coral'
}, {
  label: 'Cut',
  tint: 'bg-white text-inkDeep'
}, {
  label: 'Build',
  tint: 'bg-white text-coral'
}, {
  label: 'Play',
  tint: 'bg-white text-inkDeep'
}];
export function Hero() {
  const scrollToBuy = () => {
    document.getElementById('buy')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <header className="confetti-dots relative overflow-hidden pb-12 pt-12 sm:pt-16 lg:pb-20 lg:pt-20" data-id="element-98" data-mp="xb5s7ge82vws">
      <Container className="relative" data-id="element-99" data-mp="s9gj46ak8sbc">
        <div className="mx-auto max-w-[900px] text-center" data-id="element-100" data-mp="ncgiiawhchrm">
          <span className="inline-flex items-center rounded-full border border-black/5 bg-white px-4 py-2 font-grotesque text-[11px] font-extrabold uppercase tracking-[0.18em] text-coral shadow-sm sm:text-[12px]" data-id="element-101" data-mp="neawf59c39m7">
            1,200+ printable 3D paper toys
          </span>

          <h1 className="mt-6 font-grotesque text-[34px] font-extrabold leading-[1.05] tracking-[-0.03em] sm:text-[52px] lg:text-[64px]" data-id="element-102" data-mp="3j9u0ky5t7mla">
            <span className="block text-inkDeep" data-id="element-103" data-mp="3o59cvlo65afl">Turn your child’s screen time</span>
            <span className="glow-coral mt-3 block text-coral" data-id="element-104" data-mp="39cfmh57cz9w5">
              into hours of creativity and fun
            </span>
            <span className="glow-coral mt-3 block text-coral" data-id="element-105" data-mp="30iayctjm0ckb">
              with 1,200+ 3D paper toys ready to build.
            </span>
          </h1>

          <p className="mx-auto mt-7 max-w-[540px] font-nunito text-[17px] leading-[1.6] text-inkDeep/70 sm:text-[19px]" data-id="element-106" data-mp="35aawqhk16xes">
            Print at home. Cut, fold and build. A brand-new toy whenever boredom hits.
          </p>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-2" data-id="element-107" data-mp="2vglkz78wzmt2">
            {steps.map(step => <li key={step.label} className={`rounded-full border border-black/5 px-4 py-2 font-grotesque text-[12px] font-extrabold uppercase tracking-[0.16em] shadow-sm sm:text-[13px] ${step.tint}`} data-id="element-108" data-mp="2lkike5tpnw88">
                {step.label}
              </li>)}
          </ul>
        </div>
      </Container>

      {/* LARGE PRODUCT VISUAL */}
      <Container className="relative mt-10 sm:mt-14" data-id="element-109" data-mp="dd5ews2mzp5p">
        <figure data-id="element-110" data-mp="deq6q9xkgtzv">
          <div className="relative rounded-[24px] border border-black/5 bg-white p-2 shadow-[0_28px_56px_-34px_rgba(17,24,39,0.5)] sm:p-3" data-id="element-111" data-mp="db2ct9o7m5km">
            <div className="overflow-hidden rounded-[16px]" data-id="element-112" data-mp="161az9dps3c50">
              <img src={heroImage.src} alt={heroImage.alt} className="aspect-[4/3] w-full object-cover sm:aspect-[16/10]" data-id="element-113" data-mp="15zq0td0cf91v" />
            </div>

            <span className="absolute -right-2 -top-3 rotate-3 rounded-full bg-coral px-4 py-2 font-grotesque text-[12px] font-extrabold uppercase tracking-[0.12em] text-white shadow-[0_6px_0_#C43A1C] sm:-right-3 sm:text-[14px]" data-id="element-114" data-mp="x3h2k1o3qghb">
              Mega pack
            </span>
          </div>

          <figcaption className="mt-7" data-id="element-115" data-mp="1x784bltydnt2">
            <ul className="mx-auto flex max-w-[680px] flex-wrap items-center justify-center gap-x-2.5 gap-y-2" data-id="element-116" data-mp="21aekpmas4vd9">
              {flow.map((label, index) => <React.Fragment key={label} data-id="element-117" data-mp="267wjwkyzvw82" data-mpi={index}>
                  {index > 0 && <li aria-hidden="true" className="font-grotesque text-base font-extrabold text-coral" data-id="element-118" data-mp="2b2agurtb2beu">
                      →
                    </li>}
                  <li className="rounded-full border border-black/5 bg-white px-4 py-2 font-nunito text-[14px] font-bold text-inkDeep shadow-sm sm:text-[15px]" data-id="element-119" data-mp="2kxucdd3yj832">
                    {label}
                  </li>
                </React.Fragment>)}
            </ul>
          </figcaption>
        </figure>

        <div className="mx-auto mt-9 max-w-[460px]" data-id="element-120" data-mp="unraoxe69lte">
          <button type="button" onClick={scrollToBuy} className="btn-3d" data-id="element-121" data-mp="zlappzip22me">
            Get instant access
          </button>
          <p className="mt-4 text-center font-nunito text-[14px] font-bold text-inkDeep/60" data-id="element-122" data-mp="4akx2ytnmkfz">
            Instant digital access · One-time payment
          </p>
        </div>
      </Container>
    </header>;
}